import { render, staticRenderFns } from "./EtapaEstacionamento.vue?vue&type=template&id=56a393a6"
import script from "./EtapaEstacionamento.vue?vue&type=script&lang=js"
export * from "./EtapaEstacionamento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports